module.exports = __webpack_public_path__ + "img/preview-6.2f874745.webp";